import { z } from 'zod';
import { createResourceSchema, resourceSourceSchema } from './resource.js';

export const webhookLogStatusSchema = z.enum(['success', 'failed', 'error']);
export type WebhookLogStatus = z.infer<typeof webhookLogStatusSchema>;

export const webhookLogSchema = z.object({
  id: z.string(),
  status: webhookLogStatusSchema,
  error: z.string().nullable().default(null),
  resourceTitle: z.string().nullable().default(null),
  category: z.string().nullable().default(null),
  source: resourceSourceSchema.nullable().default(null),
  tokenId: z.string().nullable().default(null),
  payload: z.record(z.unknown()),
  timestamp: z.string().datetime(),
});
export type WebhookLog = z.infer<typeof webhookLogSchema>;

export const webhookResourcePayloadSchema = createResourceSchema.extend({
  webhookId: z.string().optional(),
});
export type WebhookResourcePayload = z.infer<typeof webhookResourcePayloadSchema>;

export const githubWebhookPingSchema = z.object({
  zen: z.string(),
  hook_id: z.number().optional(),
  repository: z.unknown().optional(),
});
export type GithubWebhookPing = z.infer<typeof githubWebhookPingSchema>;
